module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/savings-2585b1e65fc3630c65a4b52a6515f724.jpg";